// Controlled masked phone input. Live-formats US numbers to
// "(555) 123-4567" as the user types. Mirrors ECU_Database's
// setupPhoneInput pattern from frontend/utils.js:1062.
//
// Storage convention: callers receive the formatted string in their
// onChange handler. On form submit, run the value through
// stripPhoneForStorage() to get the 10-digit canonical form.

import type { InputHTMLAttributes } from 'react';
import { formatPhoneAsTyped } from '../utils/phone';

type Inherited = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'type' | 'inputMode'
>;

export interface PhoneInputProps extends Inherited {
  /** Current value — typically the formatted "(###) ###-####" string. */
  value: string;
  /** Called with the re-formatted string on every keystroke. */
  onChange: (next: string) => void;
}

export function PhoneInput(props: PhoneInputProps): JSX.Element {
  const { value, onChange, className, placeholder, ...rest } = props;
  return (
    <input
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      className={`form-input ${className ?? ''}`}
      placeholder={placeholder ?? '(555) 123-4567'}
      value={value}
      onChange={(e) => onChange(formatPhoneAsTyped(e.target.value))}
      maxLength={16} /* "(555) 123-4567" = 14, slack for paste */
      {...rest}
    />
  );
}
